import { FC } from "react";
import { components } from "react-select";
import styled, { css } from "styled-components";
import { styleWrappedComponent } from "./styleWrappedComponent";
import { SelectComponentProps } from "./types";

const StyledMenu = styled.div`
  ${styleWrappedComponent(css`
    overflow: hidden;
    border-radius: var(--size-border-radius-small);
    border: none;
    box-shadow: var(--elevation-2);
  `)};
`;

type MenuProps = SelectComponentProps["Menu"];

export const Menu: FC<MenuProps> = ({ children, ...props }) => (
  <StyledMenu>
    <components.Menu {...props}>{children}</components.Menu>
  </StyledMenu>
);
